import { genPopulateAttr } from '@utils/util';

export const peopleAndGroupAttributes = (): string => {
  const attributes = [['image'], ['student_orgs'], ['professional_orgs']];
  return attributes.map(it => genPopulateAttr(it)).join('&');
};
